import React from 'react'
import styled from 'styled-components'
import FormatPrice from 'components/FormatPrice'
import SquareMeters from 'components/SquareMeters'

const StyledTable = styled.table`
  tr {
    &:nth-child(even) td {
      background: #e9e9e9;
    }

    td {
      padding: 0.5rem 1.5rem;

      &:first-child {
        font-weight: 700;
      }

      &:last-child {
        text-align: right;
      }

      &:only-child {
        text-align: center;
      }
    }
  }
`

const insertIf = (condition, ...elements) => {
  return condition ? elements : []
}

const Table = ({ data = null }) => {
  const rows = React.useMemo(() => {
    return data
      ? [
          ...insertIf(data.hverfid, ['Hverfi', data.hverfid.title]),
          ...insertIf(data.afangi, ['Áfangi', data.afangi.title]),
          ...insertIf(data.title, ['Lóð', data.title]),
          ...insertIf(data.lodarstaerd, ['Lóðarstærð', <SquareMeters area={data.lodarstaerd} />]),
          ...insertIf(data.lodargerd, ['Lóðargerð', data.lodargerd]),
          ...insertIf(data.byggingarmagn_mest, [
            'Hámarks byggingarmagn',
            <SquareMeters area={data.byggingarmagn_mest} />,
          ]),
          ...insertIf(data.nytingarhlutfall, ['Nýtingarhlutfall', data.nytingarhlutfall]),
          ...insertIf(data.fjoldi_ibuda && data.fjoldi_ibuda !== '0', [
            'Fjöldi íbúða',
            data.fjoldi_ibuda,
          ]),
          ...insertIf(data.haedir && data.haedir !== '0', ['Fjöldi hæða', data.haedir]),
          ...insertIf((data.verd && data.verd !== '0') || data.seld, [
            <>
              Gatnagerðargjöld
              <br />
              (þjónustugjöld ekki innifalin)
            </>,
            data.seld ? 'LÓÐ ÚTHLUTAÐ' : <FormatPrice price={data.verd} />,
          ]),
          ...insertIf(data.byggingarrettargjald && !data.seld, [
            'Byggingarréttargjald',
            <FormatPrice price={data.byggingarrettargjald} />,
          ]),
          ...insertIf(data.byggingarrettargjald_utbod && !data.seld, [
            'Byggingarréttargjald',
            data.byggingarrettargjald_utbod,
          ]),
          ...insertIf(data.uppgroftur_fylling_vegna_gatnagerdar && !data.seld, [
            'Uppgröftur/fylling vegna gatnagerðar',
            <FormatPrice price={data.uppgroftur_fylling_vegna_gatnagerdar} />,
          ]),
          ...insertIf(data.lagmarkstilbodsverd && !data.seld, [
            'Lágmarkstilboðsverð',
            <FormatPrice price={data.lagmarkstilbodsverd} />,
          ]),
          ...insertIf(data.byggingarrettargjald_utbod === 'Tilboð', [
            'þjónustugjöld ekki innifalin',
          ]),
        ]
      : []
  }, [data])

  return data ? (
    <StyledTable className="w-100 bg-white" cellspacing={0} cellpadding={0}>
      <tbody>
        {rows.map((cells, rowIdx) => {
          let cellProps = cells.length === 1 ? { colspan: 2 } : {}

          return (
            <tr key={rowIdx}>
              {cells.map((cell, cellIdx) => (
                <td key={cellIdx} {...cellProps}>
                  {cell}
                </td>
              ))}
            </tr>
          )
        })}
      </tbody>
    </StyledTable>
  ) : null
}

export default Table
